<template>
  <div class="d-flex flex-column">
    <Header step="2">
      <template #header-text>
        What do you need help with?
      </template>
    </Header>

    <div class="ma-2 pt-6 pb-3 px-3 white rounded d-flex flex-column align-center" style="gap: 12px;">
      <PropertyButton 
        v-for="type in propertyTypes" 
        :key="type.key" 
        :type="type"
        @click="onClick(type.key)"
      />

      <v-btn @click="$router.replace({ name: 'qr/wizard/category' })">Back</v-btn>
    </div>

    <WizardOverlay 
      v-model="error_dialog"
      @close="$router.replace({ name: 'qr' })"
    />
  </div>
</template>

<script>
import Header from '../Header'
import PropertyButton from './PropertyButton'
import { WizardOverlay } from '@/components/pages'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'QRCategoryView',

  components: { Header, PropertyButton, WizardOverlay },

  data: () => ({
    loading: false,
    error_dialog: false,

    propertyTypes: [
      { key: 'traditional', imageUrl: require('@/assets/wizard/home.png'), name: 'Residential', },
      { key: 'mobile_home', imageUrl: require('@/assets/wizard/mh.png'), name: 'Mobile Home', },
      { key: 'rv', imageUrl: require('@/assets/wizard/rv.png'), name: 'RV', },
    ],
  }),

  computed: {
    ...mapGetters('qr', ['request'])
  },

  methods: {
    ...mapActions('qr', ['missingStageRequirements', 'setPropertyType']),

    onClick(structure_type) {
      this.setPropertyType({ structure_type })

      this.$router.replace({ name: 'qr/wizard/notes'})
    }
  },

  async created() {
    const result = await this.missingStageRequirements(2)
    if (result) {
      this.error_dialog = true
    }
  },
}
</script>